import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

export const parseHtmlFromString = (htmlString: string) => {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  });

  const cleanHtmlString = DOMPurify.sanitize(htmlString, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
    FORBID_ATTR: ['style'],
  });
  return parse(cleanHtmlString);
};
